
export const GET_TIME_TABLE_IN_PROGRESS = " GET_TIME_TABLE_IN_PROGRESS"
export const GET_TIME_TABLE_COMPLETE = " GET_TIME_TABLE_COMPLETE"
export const GET_TIME_TABLE_FAILED = " GET_TIME_TABLE_FAILED"